import { Button, Col, Typography } from "antd";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

import { WrapperModalConfigurationCashback } from "../../../../modules";
import {
  selectIsUpdateIpAccessRules,
  selectModalIpAccessRules,
  selectIpAccessRulesForUpdate,
} from "../../../../redux";
import { DataIpAccessRules } from "../../../../redux/@types";
import { InputText, InputSelect } from "../inputs";
import { useIpAccessRules } from "../../../../modules/ipAccessRules";

const { Title } = Typography;

export const ModalIpAccessRules = () => {
  const modalIpAccessRules = useSelector(selectModalIpAccessRules);
  const isUpdateIpAccessRules = useSelector(selectIsUpdateIpAccessRules);
  const updateIpAccessRules = useSelector(selectIpAccessRulesForUpdate);

  const {
    isLoading,
    changeModalIpAccessRulesState,
    onSubmitCreateOrUpdate,
  } = useIpAccessRules();

  const { control, handleSubmit: onSubmit } =
    useFormContext<DataIpAccessRules>();

  return (
    <WrapperModalConfigurationCashback
      title={
        isUpdateIpAccessRules
          ? `Actualizando regla IP: '${updateIpAccessRules?.id!}'`
          : `Nueva regla de IP`
      }
      open={modalIpAccessRules}
      width={"360px"}
      destroyOnClose
      onClose={changeModalIpAccessRulesState}
    >
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          IP:
        </Title>
        <InputText placeHolder="Ej: 190.24.1.10" name="ip" control={control} />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Tipo:
        </Title>
        <InputSelect
          label="Tipo"
          name="type"
          control={control}
          dataOptions={[
            { value: "block", title: "Bloqueo" },
            { value: "allow", title: "Lista blanca" },
          ]}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Estado:
        </Title>
        <InputSelect
          label="Estado"
          name="status"
          control={control}
          dataOptions={[
            { value: "active", title: "Activa" },
            { value: "inactive", title: "Inactiva" },
          ]}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Motivo:
        </Title>
        <InputText
          placeHolder="Motivo del bloqueo o whitelist"
          name="reason"
          control={control}
        />
      </Col>
      <Button
        style={{
          width: "100%",
          marginTop: 20,
        }}
        type="primary"
        shape="round"
        size="large"
        loading={isLoading}
        onClick={onSubmit(onSubmitCreateOrUpdate)}
      >
        {isUpdateIpAccessRules ? "Actualizar" : "Guardar"}
      </Button>
    </WrapperModalConfigurationCashback>
  );
};
